// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Component } from "react";

import { PageHeader, PageContent } from "components/layout";
import { trans } from "src/translations";

import { InviteUserData } from "./InviteUserData";

export class InviteUser extends Component {
  render() {
    return (
      <div>
        <PageHeader>{trans.USER_INVITE__PAGE_HEADER()}</PageHeader>
        <PageContent>
          <InviteUserData />
        </PageContent>
      </div>
    );
  }
}
